var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuDivitPromotion2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_369)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17C13 16.5858 13.3358 16.25 13.75 16.25H21C21.4142 16.25 21.75 16.5858 21.75 17C21.75 17.4142 21.4142 17.75 21 17.75H13.75C13.3358 17.75 13 17.4142 13 17Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80208 3.7446C5.147 3.42267 5.60441 3.25 6.07143 3.25H18.9286C19.3956 3.25 19.853 3.42267 20.1979 3.7446C20.5446 4.06816 20.75 4.51852 20.75 5V13C20.75 13.4815 20.5446 13.9318 20.1979 14.2554C19.853 14.5773 19.3956 14.75 18.9286 14.75H11.6964C11.2822 14.75 10.9464 14.4142 10.9464 14C10.9464 13.5858 11.2822 13.25 11.6964 13.25H18.9286C19.0299 13.25 19.1175 13.212 19.1744 13.1588C19.2296 13.1073 19.25 13.049 19.25 13V5C19.25 4.95105 19.2296 4.89269 19.1744 4.84118C19.1175 4.78804 19.0299 4.75 18.9286 4.75H6.07143C5.97012 4.75 5.88249 4.78804 5.82555 4.84118C5.77036 4.8927 5.75 4.95105 5.75 5V7.5C5.75 7.91421 5.41421 8.25 5 8.25C4.58579 8.25 4.25 7.91421 4.25 7.5V5C4.25 4.51852 4.4554 4.06816 4.80208 3.7446Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_100_369)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_100_369",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 8,
    width: 14,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.792 8H0V21.8H13.792V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_100_369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.89573 10.3324C5.84288 10.3324 4.98938 11.1859 4.98938 12.2388C4.98938 13.2916 5.84288 14.1451 6.89573 14.1451C7.94857 14.1451 8.80207 13.2916 8.80207 12.2388C8.80207 11.1859 7.94857 10.3324 6.89573 10.3324ZM3.48938 12.2388C3.48938 10.3575 5.01445 8.83241 6.89573 8.83241C8.777 8.83241 10.3021 10.3575 10.3021 12.2388C10.3021 14.12 8.777 15.6451 6.89573 15.6451C5.01445 15.6451 3.48938 14.12 3.48938 12.2388Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12507 17.425C4.75821 17.425 4.39496 17.4973 4.05606 17.6378C3.71716 17.7782 3.40927 17.9841 3.14997 18.2436C2.89068 18.5031 2.68507 18.8112 2.5449 19.1502C2.40474 19.4892 2.33275 19.8526 2.33307 20.2194C2.33343 20.6336 1.99793 20.9697 1.58372 20.9701C1.16951 20.9704 0.833429 20.6349 0.83307 20.2207C0.832582 19.6568 0.943238 19.0983 1.15871 18.5771C1.37419 18.0559 1.69026 17.5824 2.08885 17.1834C2.48745 16.7845 2.96076 16.468 3.48173 16.2521C4.00271 16.0361 4.56112 15.925 5.12507 15.925H8.66707C9.23101 15.925 9.78943 16.0361 10.3104 16.2521C10.8314 16.468 11.3047 16.7845 11.7033 17.1834C12.1019 17.5824 12.4179 18.0559 12.6334 18.5771C12.8489 19.0983 12.9596 19.6568 12.9591 20.2207C12.9587 20.6349 12.6226 20.9704 12.2084 20.9701C11.7942 20.9697 11.4587 20.6336 11.4591 20.2194C11.4594 19.8526 11.3874 19.4892 11.2472 19.1502C11.1071 18.8112 10.9015 18.5031 10.6422 18.2436C10.3829 17.9841 10.075 17.7782 9.73608 17.6378C9.39718 17.4973 9.03392 17.425 8.66707 17.425H5.12507Z",
    fill: "#1C1C1C"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.256592)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_100_369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.792,
    height: 13.8,
    fill: "white",
    transform: "translate(0 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDivitPromotion2);
export default __webpack_public_path__ + "static/media/menu-divit-promotion-2.d8304ae21aff7dc3e5798fc18370adb8.svg";
export { ForwardRef as ReactComponent };